module.exports = __webpack_public_path__ + "static/media/DSC_0703-2.a331cda7.jpg";